

export default {
    name: 'AticleLoading',
    computed: {
        skinColor() {
            return this.$store.state.skinColor;
        },
    },
}


// WEBPACK FOOTER //
// ./src/components/ArticleLoading/ArticleLoading.js